import { HowItWorkCarouselProps } from 'libs/growth-platform-brand-system-v2/src/layouts/HowItWorkCarousel/index';
import morphism, { createSchema } from 'morphism';
import { schemaImage } from '../components/schemaImage';

export const schemaHowItWork = createSchema<HowItWorkCarouselProps, any>({
  title: 'title',
  content: {
    path: ['items', 'pixelDensity'],
    fn: ({ items, pixelDensity }: any) => {
      return items.map((item: any) => ({
        isCounter: item.isCounter,
        title: item.title,
        description: item.subtitle,
        image: morphism(schemaImage, { ...item.image, pixelDensity }),
      }));
    },
  },
});
